import React from 'react';
import { Box } from '@mui/material';
import TimeSliderPerformance from '../components/sliders/slider_performance.js';
import './styles/view-performance.css';
// Graphs
import TemporalGraph from '../components/performance-components/graph_temporal.js';
import MetricsBelowMap from '../components/performance-components/metrics_below_map.js';
// Custom hooks
import { usePerformanceState } from '../hooks/usePerformanceState.js';
import { useAuthentication } from '../hooks/useAuthentication.js';
// Configuration
import { getModelDisplayName, getMetricsName } from '../config/performance.js';
// Components
import TabPanel from '../components/common/TabPanel.js';
import BottomTabBar from '../components/performance-components/BottomTabBar.js';
import MapContainer from '../components/performance-components/MapContainer.js';
import ButtonsContainer from '../components/performance-components/ButtonsContainer.js';
import LoadingBackdrop from '../components/common/LoadingBackdrop.js';

/**
 * Performance Visualization Component
 * Displays weather forecast models and ground truth data with interactive controls
 */


function PerformanceVisualization() {
  // Custom hooks for state management
  const {
    cqlSevere,
    cqlFecha,
    cqlFechaMin,
    cqlFechaMax,
    weekNumber,
    mapLeftLayer,
    mapRightLayer,
    selectedModel,
    issueTime,
    selectedTime,
    issueTimeOptions,
    tabIndex,
    backdropOpen,
    setIssueTimeOptions,
    handleDateChange,
    handleModelClick,
    handleRiskClick,
    handleDateSelect,
    handleTimeSelect,
    handleTabChange,
    handleBackdropOpen,
    handleBackdropClose,
  } = usePerformanceState();

  // Authentication hook
  const { isAuthenticatedRight, handleLogin } = useAuthentication();

  // Computed values
  const prettyModelName = getModelDisplayName(selectedModel);
  const metricsName = getMetricsName(selectedModel);








  // Definir referencias para sincronizar ambos mapas
  // const mapLeftRef = useRef(null);
  // const mapRightRef = useRef(null);
  // const { syncMaps } = useMapSync();
  // const handleSyncClick = () => {
  //   if (mapLeftRef.current) {
  //     const leftMapState = {
  //       center: mapLeftRef.current.getCenter(),
  //       zoom: mapLeftRef.current.getZoom(),
  //     };
  //     syncMaps(leftMapState);
  //   }
  // };
  // useEffect(() => {
  //   let rightLayer = mapLeftLayer;
  //   // lógica para mapRightLayer basado en mapLeftLayer y cqlSevere...
  //   setMapRightLayer(rightLayer);
  // }, [mapLeftLayer, cqlSevere]);

  return (
    <div className="analytics-container">
      <TabPanel value={tabIndex} index={0} sx={{ padding: 0, margin: 0 }}>
        <MapContainer
          prettyModelName={prettyModelName}
          issueTime={issueTime}
          cqlSevere={cqlSevere}
          cqlFecha={cqlFecha}
          mapLeftLayer={mapLeftLayer}
          weekNumber={weekNumber}
          selectedTime={selectedTime}
          isAuthenticatedRight={isAuthenticatedRight}
          mapRightLayer={mapRightLayer}
          selectedModel={selectedModel}
          onLogin={handleLogin}
        />

        <MetricsBelowMap
          metricsNames={metricsName}
          cqlFecha={cqlFecha}
          weekNumber={weekNumber}
          issueTime={issueTime}
          cqlSevere={cqlSevere}
          handleRiskClick={handleRiskClick}
          mapLeftLayer={mapLeftLayer}
        />

        <ButtonsContainer
          cqlFecha={cqlFecha}
          selectedModel={selectedModel}
          cqlFechaMax={cqlFechaMax}
          cqlFechaMin={cqlFechaMin}
          issueTimeOptions={issueTimeOptions}
          issueTime={issueTime}
          onDateChange={handleDateChange}
          onModelClick={handleModelClick}
          onDateSelect={handleDateSelect}
          onTimeSelect={handleTimeSelect}
          onBackdropOpen={handleBackdropOpen}
          onBackdropClose={handleBackdropClose}
          setIssueTimeOptions={setIssueTimeOptions}
        />

        <div>
          <TimeSliderPerformance 
            initialDate={cqlFechaMin} 
            steps={24} 
            onChange={handleDateChange} 
            cqlFechaMin={cqlFechaMin}
          />
        </div>
      </TabPanel>

      <BottomTabBar tabIndex={tabIndex} onTabChange={handleTabChange} />

      <TabPanel value={tabIndex} index={1}>
        <div className="graphic-time-performance">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              marginX: 2,
              position: 'relative',
              cursor: 'crosshair',
            }}
          >
            <Box sx={{ paddingTop: '-30px' }}>
              <TemporalGraph 
                cqlFecha={cqlFecha} 
                cqlFechaMax={cqlFechaMax} 
                cqlFechaMin={cqlFechaMin} 
                issueTime={issueTime} 
                cqlSevere={cqlSevere} 
                weekNumber={weekNumber} 
                metricsNames={metricsName} 
                issueTimeOptions={issueTimeOptions} 
                selectedTime={selectedTime} 
                handleRiskClick={handleRiskClick} 
                mapLeftLayer={mapLeftLayer} 
              />
            </Box>
          </Box>
        </div>
        
        <ButtonsContainer
          cqlFecha={cqlFecha}
          selectedModel={selectedModel}
          onDateChange={handleDateChange}
          onModelClick={handleModelClick}
          showAllButtons={false}
        />

      {/* <div className="graphic-table-performance">
        <DataTable cqlFecha={cqlFecha} cqlFechaMax={cqlFechaMax} cqlFechaMin={cqlFechaMin} issueTime={issueTime} cqlSevere={cqlSevere} weekNumber={weekNumber} metricsNames={metricsNames[selectedModel]} selectedTime={selectedTime}/>
      </div>       */}


      <div className="graph-container2">
      {/* <h3 className='title'>Accuracy achieved in {cqlFecha}</h3> */}
         {/* <AccuracyChart  cqlFecha={cqlFecha} cqlSevere={cqlSevere}/>  */}
         
      </div>

      <div className="graphic-radar">
        {/* <h3 className='title'>Spatial Resolution</h3> */}
        {/* <RadarChart cqlFecha={cqlFecha} cqlSevere={cqlSevere} weekNumber={weekNumber} metricsNames={metricsNames[selectedModel]}issueTime={issueTime} />  */}
      </div>

      <div className="graph-container3">
        {/* <h3 className='title'>Spatial Resolution</h3> */}
        {/* <BarLineChart cqlFecha={cqlFecha} />  */}
      </div>
      </TabPanel>

      <LoadingBackdrop open={backdropOpen} />
    </div>   
  );
}

export default PerformanceVisualization;
